import { render, staticRenderFns } from "./clean.vue?vue&type=template&id=35eeb868&scoped=true&"
import script from "./clean.vue?vue&type=script&lang=js&"
export * from "./clean.vue?vue&type=script&lang=js&"
import style0 from "./clean.vue?vue&type=style&index=0&id=35eeb868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eeb868",
  null
  
)

export default component.exports